import dayjs from "dayjs";

export const removeDay = (date, countDay) => {
  return dayjs(date).subtract(countDay, "day").format("YYYY-MM-DD");
};
